import { MapPin, Camera, HandHelping, CalendarCheck } from "lucide-react";

/**
 * Service-quality trust cards. Deliberately no invented statistics, * these can be swapped for real job/customer numbers once OZ WASTE CO.
 * has built its own track record.
 */
const cards = [
  { icon: MapPin, title: "Melbourne Based", description: "Local Service" },
  { icon: Camera, title: "Photo Quotes", description: "Easy Assessment" },
  { icon: HandHelping, title: "Heavy Lifting", description: "Handled For You" },
  { icon: CalendarCheck, title: "Simple Booking", description: "From Quote to Pickup" },
];

const SocialProofStats = () => (
  <section className="bg-[#fafafa] py-20 md:py-28">
    <div className="container max-w-6xl text-center">
      <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] leading-tight tracking-tight">
        Built for Simple, Reliable Rubbish Removal
      </h2>
      <p className="text-[#1a1a1a]/70 mt-2 text-base mb-14">
        Straightforward service, clear communication and no guesswork.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mx-auto">
        {cards.map((c) => (
          <div
            key={c.title}
            className="group relative h-full bg-white/70 backdrop-blur-xl border border-[#1a1a1a]/5 rounded-[2rem] p-8 shadow-[0_20px_50px_rgba(0,0,0,0.05)] hover:shadow-[0_30px_60px_rgba(0,0,0,0.1)] transition-all duration-500 hover:-translate-y-2 flex flex-col items-center text-center"
          >
            <div className="w-16 h-16 rounded-2xl bg-[#FDC00E]/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-500">
              <c.icon className="w-7 h-7 text-[#1a1a1a]" strokeWidth={1.8} />
            </div>
            <p className="text-xl md:text-2xl font-black text-[#1a1a1a] leading-tight tracking-tight">
              {c.title}
            </p>
            <p className="text-[#1a1a1a]/70 text-sm mt-1.5">{c.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProofStats;
